import { instance } from '@/libs/api/instance.js'

/**
 * @param { string } id - Card uuid
 *
 * @returns {Promise<AxiosResponse<any>>}
 */

export const getLimits = (id) => {
  return instance.post(`/v2/card/${id}/calculate/limits`)
}
